import ProjectsTable from './ProjectsTable';
export default ProjectsTable;
